import React, { Fragment } from "react";
import { modal } from "components/HeadlessModal";
import PrimaryButton from "components/Buttons/PrimaryButton";
import LowTextInput from "components/FormElements/LowTextInput";
import Label from "components/FormElements/Label";
import { toast } from "react-hot-toast";
import { buildProxyUrl } from "helpers/Request";

const requestClipboardWrite = (data) => {
    navigator.clipboard.writeText(data).then(() => {
        toast.success("URL copied to clipboard");
    });
};

export function handleShowFeed(auth, settings) {
    const urlBase =
        buildProxyUrl("/v4/serv/planner/ics", auth.publication) +
        "?id=" +
        auth.user.uuid +
        "&k=" +
        settings.env.server_key;

    modal({
        title: "Calendar Feeds",
        children: (
            <Fragment>
                View assignments in your calendar by subscribing to the calendar
                feed. Copy the URL below and add it to your calendar
                application.{" "}
                <a
                    href="/help/planner/calendar-feeds.html"
                    target="_blank"
                    rel="noreferrer, noopener"
                    className="text-underline cursor-pointer text-green-600"
                >
                    More information
                </a>
                .
                <div className="mt-4 space-y-4">
                    <div>
                        <Label>My assignments and mentions</Label>
                        <div className="flex space-x-2">
                            <div className="flex-grow">
                                <LowTextInput
                                    value={urlBase + "&type=mine"}
                                    readOnly
                                />
                            </div>
                            <button
                                type="button"
                                onClick={requestClipboardWrite.bind(
                                    null,
                                    urlBase + "&type=mine"
                                )}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="m-2 h-6 w-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div>
                        <Label>All assignments</Label>
                        <div className="flex space-x-2">
                            <div className="flex-grow">
                                <LowTextInput
                                    value={urlBase + "&type=all"}
                                    readOnly
                                />
                            </div>
                            <button
                                type="button"
                                onClick={requestClipboardWrite.bind(
                                    null,
                                    urlBase + "&type=all"
                                )}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="m-2 h-6 w-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </Fragment>
        ),
        buttons: () => (
            <PrimaryButton
                onClick={() => {
                    modal.dismiss();
                }}
            >
                Close
            </PrimaryButton>
        ),
    });
}
